import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function queryConsentSetting(): Promise<ConsentSetting> {
  const res = await fetchOrchidAPI("/api/users/v1/orchid_pro/consent_setting");
  if (!res.ok) {
    throw new Error(
      `failed to fetch consent setting: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
